import type {FacebookLikePostVerificationAttemptData} from '@cohort/shared/apps/facebook/triggers/likePost';
import {Trans} from 'react-i18next';

const FacebookLikePostTriggerIntegrationStepCompletionTitleComponent: React.FC<{
  data: FacebookLikePostVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data, completionSuccess}) => {
  const {username} = data;

  if (!completionSuccess) {
    return (
      <Trans
        i18nKey="triggers.like-post.stepCompletionTitleComponent.error"
        ns="app-facebook"
        values={{username}}
      />
    );
  }

  return (
    <Trans
      i18nKey="triggers.like-post.stepCompletionTitleComponent.success"
      ns="app-facebook"
      values={{username}}
    />
  );
};

export default FacebookLikePostTriggerIntegrationStepCompletionTitleComponent;
